import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { initialize } from '../store/slices/userSlice';

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const { isAuthenticated, user, token } = useSelector((state) => state.user);

  // Initialize user state on app load
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');
    const adresse_facturation = localStorage.getItem('adresse_facturation');

    
    if (storedUser && storedToken) {
      // Dispatch initialization to Redux store
      dispatch(
        initialize({ 
        isAuthenticated: true, 
        user: JSON.parse(storedUser), 
        token: storedToken ,
        adresse_facturation:adresse_facturation ?JSON.parse(adresse_facturation):null,
      })        );
    } else {
      dispatch(initialize({ isAuthenticated: false, user: null, token: null }));
    }
    setLoading(false);
  }, [dispatch]);

  // While loading, show a loading indicator
  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if the user is authenticated and has a valid token
  if (!isAuthenticated || !token) {
    // If the user is not authenticated or the token is invalid, redirect to the login page
    return <Navigate to="/login" />;
  }

  // If authenticated and token is valid, render the protected content
  return children;
};

export default PrivateRoute;
